import {useCurrentAccentColor, AccentColorOptions} from 'epic-ue-theme';
import {Typography} from '../typography';
import React from 'react';
import styled from 'styled-components';
import { VerticalSpacer } from '../spacer';

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

const Styled = styled.div<{$accentColor: string}>`
    border: 4px solid;
    border-image: ${(p) =>
            getRadialGradient(
                p.theme.palette.gradient[p.$accentColor].from,
                p.theme.palette.gradient[p.$accentColor].to
            )}
        5;
    border-image-width: 4px;
    margin: 0 auto;
    width: 400px;
    height: auto;
    padding: 40px;
    background-color: transparent;
    border-radius: 0;
    box-shadow: none;
    text-align: center;

    ${(p) => p.theme.breakpoints.down('sm')} {
        width: auto;
        max-width: 400px;
    }
`;

interface Props {
    msg?: string;
}

export const FeatureUnavailable = ({msg}: Props) => {
    const {name} = useCurrentAccentColor();
    const accentColor = (name as AccentColorOptions) || 'sky';

    return (
        <>
        <VerticalSpacer variant='heading' />
        <Styled $accentColor={accentColor}>
            <Typography variant="h3">
                {msg ||
                    'This feature is unavailable as your account does not meet the necessary requirements.'}
            </Typography>
        </Styled>
        </>
    );
};
